import { render, staticRenderFns } from "./matching.vue?vue&type=template&id=02be26bc&scoped=true&"
import script from "./matching.vue?vue&type=script&lang=js&"
export * from "./matching.vue?vue&type=script&lang=js&"
import style0 from "./matching.vue?vue&type=style&index=0&lang=css&"
import style1 from "./matching.vue?vue&type=style&index=1&id=02be26bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02be26bc",
  null
  
)

export default component.exports